import Lazy from 'lodash';
import { action } from 'mobx';
import React from 'react';
import { withRouter } from 'react-router-dom';

import Utils from '../../../../utils';

@withRouter
class File extends React.Component {
  static defaultProps = {
    name: '',
    onCloseMenu: () => {},
    onRunTemplate: () => {}
  };

  render() {
    const name = Utils.niceFileName(this.props.name);
    const icon = Utils.getIcon(this.props.name);
    return (
      <li>
        {icon}
        <span onClick={this.onClick}>{name}</span>
      </li>
    );
  }

  @action.bound
  onClick() {
    let { path } = this.props;
    const viewFileTypes = ['html', 'lhtml', 'wtletter', 'wtemail', 'wtprint'];
    const ext = path.match(/[^.]+$/gim)[0] || '';

    const replaced = path.replace(/\\|\//g, '/').replace(/^\//gim, '');

    const url = encodeURIComponent(replaced);

    this.props.onCloseMenu();

    if (!Lazy(viewFileTypes).includes(ext)) {
      return window.open(`/api/download?path=${url}`);
    }

    this.props.onRunTemplate(url);
  }
}

export default File;
